module.exports = __webpack_public_path__ + "img/icon-print.31d5e0c3.svg";